module.exports = __webpack_public_path__ + "img/83_20.35306d49.png";